/**
 * Normalize predecessor / successor / children id lists from API payloads.
 * Filters empty strings and nulls — raw DB values like [""] or "" must not count as links.
 */

export function parseEntityIdArray(value) {
  if (value == null) return [];

  if (Array.isArray(value)) {
    return value.map((v) => String(v).trim()).filter(Boolean);
  }

  if (typeof value === "string") {
    const s = value.trim();
    if (!s || s === "[]" || s === "null" || s === "undefined") return [];
    try {
      const parsed = JSON.parse(s);
      if (Array.isArray(parsed)) {
        return parsed.map((v) => String(v).trim()).filter(Boolean);
      }
      if (parsed == null) return [];
      const one = String(parsed).trim();
      return one ? [one] : [];
    } catch {
      return s
        .split(/[\s,;]+/)
        .map((part) => part.trim())
        .filter(Boolean);
    }
  }

  return [];
}
